import { h } from 'preact';
import getJSON from '../utils/get-json';
import PureComponent from './PureComponent';

import { PreactHTMLConverter } from 'preact-html-converter';

const converter = PreactHTMLConverter();

class CountyInfo extends PureComponent {
  constructor() {
    super();

    this.state = { data: null, isLoaded: false };
  }

  componentDidMount() {
    this.fetchAddress();
  }

  componentDidUpdate(prevProps) {
    if (this.props.fips !== prevProps.fips) {
      this.fetchAddress();
    }
  }

  fetchAddress() {
    const { county } = this.props;
    const slug = county.toLowerCase().replace(/\s+/g, '');

    getJSON(`${process.env.PUBLIC_PATH}api/counties/${slug}.json`).then(
      data => {
        this.setState({ data, isLoaded: true });
      }
    );
  }

  render() {
    const { county } = this.props;
    const { data, isLoaded } = this.state;

    if (!isLoaded) return null;

    document.getElementsByClassName('intro-prose')[0].style.display = 'none';

    return (
      <div class="t-serif t-links-underlined has-page-padding">
        <p class="t-copy">
          Because you shared your location with us, we were able to determine
          you are in <span class="font-weight-bold">{county} County</span>. Your
          primary election contact is{' '}
          <span class="font-weight-bold">
            {data.admin_title} {converter.convert(data.name)}
          </span>
          . To learn more about your local and county races and see a sample
          ballot,{' '}
          <a class="t-links-underlined" href={data.web_site}>
            you can visit the county's website
          </a>
          , or call the election office at{' '}
          <span class="font-weight-bold">{data.phone_number}</span>.
        </p>
      </div>
    );
  }
}

export default CountyInfo;
